import { httpClient } from '@api';

export default {
  fetchLastJobInfo: async (payload) => httpClient.post('job/last/info', payload),
  fetchNotifications: async (payload) => httpClient.post('notifications/list', payload),
  fetchNotificationsCount: async (payload) => httpClient.post('notifications/count', payload),
  updateNotifications: async (payload) => httpClient.post('notifications/update', payload),
};
